require('es6-promise').polyfill();
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withRouter } from "react-router";
import { CHAT_URL, DASHBOARD_URL, AUTH_PATH, UW_URL, TOP_LEVEL_PREFIX } from './config';
import Raven from "raven-js";
import loadable from '@loadable/component'
import GoogleAnalytics from "react-ga";
import QueryString from "query-string";
import { Provider } from 'react-redux';
import store from './redux/store';
import './assets/css/agilis.css';

const UserWorkspace = loadable(() => import('./components/leadgen-v2/UserWorkspace/'))
const Auth = loadable(() => import('./components/leadgen-v2/Auth/'))
const Dashboard = loadable(() => import('./components/leadgen-v2/Dashboard/'))

import ChatsForm from "./components/leadgen-v2/ChatsForm/";
import axios from 'axios';
import Modal from './components/leadgen-v2/Common/Modal';
import Button from './components/leadgen-v2/Common/Button';
import { fetchUser } from './redux/actions/user-actions';
import Msgs from './components/leadgen-v2/Common/Msgs';

var env_name = require('./env_data.json');
var env = require('./env.json')[env_name.ENV_NAME || 'local']; 


class App extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      showErrorModal: false,
      modalMessage: '',
    };
    env_name.ENV_NAME != 'production' && console.log(env)
    window.ENV = env_name.ENV_NAME;
    axios.defaults.baseURL = env.API_URL;
    axios.defaults.withCredentials = true;
    axios.interceptors.response.use(null, (err) => {
      if ((err.response && err.response.status === 400) || (err.__CANCEL__)) {
        return Promise.reject(err);
      }
      this.setState({
        showErrorModal: true,
        modalMessage: err.response.data.msg || ':( Hubo un error de red. Por favor reintente mas tarde.',
      });
      return Promise.reject(err);
    });
  }

  componentDidUpdate() {
    const qs = QueryString.parse(this.props.location.search);
    if (qs['no_scroll'] != 1) {
      window.scrollTo(0, 0);
    }
  }

  componentDidMount() {
    GoogleAnalytics.pageview(this.props.location.pathname + this.props.location.hash);

    store.dispatch(fetchUser('leadgen'));
    // Agregamos un listener para escuchar los cambios en la ruta
    this.props.history.listen((location) => {
      this.pushPageView();
    });
  }

  pushPageView = () => {
    axios.post('/api/v2/page-view/', { view: window.location.href, referrer: document.referrer });
  }

  componentWillReceiveProps(nextProps) {

    const currentPage = this.props.location.pathname + this.props.location.hash;
    const nextPage = nextProps.location.pathname + nextProps.location.hash;
    if (currentPage !== nextPage) {
      GoogleAnalytics.pageview(nextPage);
    }
  }

  closeModal = () => {
    this.setState({
      showErrorModal: false,
    });
  }

  render() {
    return (
      <Provider store={store}>
        <div>
          <Switch>
            <Route path={TOP_LEVEL_PREFIX + UW_URL} component={UserWorkspace} />
            <Route path={TOP_LEVEL_PREFIX + CHAT_URL} component={ChatsForm} />
            <Route path={TOP_LEVEL_PREFIX + AUTH_PATH} component={Auth} />
            <Route path={TOP_LEVEL_PREFIX + DASHBOARD_URL} component={Dashboard} />
          </Switch>
          <Modal width="100px" style={{ marginTop: '30px' }} showModal={this.state.showErrorModal} closeModal={this.closeModal} closeOnBlur>
            <p style={{ textAlign: 'center' }}>{this.state.modalMessage}</p>
            <Button onClick={this.closeModal}>Cerrar</Button>
          </Modal>
          <Msgs />
        </div>
      </Provider>
    );
  }
}

const AppWithRouter = withRouter(App);

ReactDOM.render(
  <Router>
    <AppWithRouter />
  </Router>,
  document.getElementById("target")
);

if (process.env.NODE_ENV == 'production') {
  Raven.config('https://ff8bb362437f47848978877eca9ca951@sentry.io/204111').install()
}
